export class MarketingItemModel {
  id?: string;
  title?: string;
  description?: string;
  primaryColor?: string;
  icon?: string;
}
